import React from 'react';
import { Avatar, ListItemIcon, ListItemText } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
var MainMenuItemContent = function (_a) {
    var icon = _a.icon, label = _a.label, isSelected = _a.isSelected;
    return (React.createElement(React.Fragment, null,
        icon && (React.createElement(ListItemIcon, null,
            React.createElement(Avatar, { sx: { bgcolor: isSelected ? 'primary.main' : 'transparent' } },
                React.createElement(AccurityIcon, { fontSize: "small", iconName: icon, color: isSelected ? 'light' : 'dark' })))),
        React.createElement(ListItemText, { className: "mainMenu__menuText " + (isSelected && 'mainMenu__menuText--selected'), primary: label })));
};
export default MainMenuItemContent;
//# sourceMappingURL=MainMenuItemContent.js.map